export const MATERIAL_STATUS_UPLOAD = 'upload';
export const MATERIAL_STATUS_PENDING = 'pending';
export const MATERIAL_STATUS_PROCESSING = 'processing';
export const MATERIAL_STATUS_EVALUATING = 'evaluating';
export const MATERIAL_STATUS_PUBLISHED = 'published';
export const MATERIAL_STATUS_APPROVED = 'approved';

export const MATERIAL_TYPE_PHOTO = 'photo';
export const MATERIAL_TYPE_VIDEO = 'video';


// WEBPACK FOOTER //
// ./src/constants/wallMaterials.js